// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'Dashboard',
    path: '/home',
    icon: getIcon('eva:pie-chart-2-fill'),
    isHideInXs: false,
    positiveAccess: [],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },

  {
    title: 'Dashboard',
    path: '/Dashboardapp',
    icon: getIcon('eva:pie-chart-2-fill'),
    isHideInXs: false,
    positiveAccess: [863],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },

  {
    title: 'Add Camera',
    path: '/add-client-camera',
    icon: getIcon('mdi:camera'),
    isHideInXs: false,
    positiveAccess: [],
    positiveUserRoles: [],
    negativeUserRoles: [37],
    negativeAccess: [],
  },
  {
    title: 'Analytics',
    path: '/client-analytics',
    icon: getIcon('eva:color-palette-outline'),
    isHideInXs: false,
    positiveAccess: [],
    positiveUserRoles: [],
    negativeUserRoles: [37],
    negativeAccess: [],
  },
  {
    title: 'Live',
    path: '/live',
    icon: getIcon('eva:video-outline'),
    isHideInXs: false,
    positiveAccess: [],
    positiveUserRoles: [],
    negativeUserRoles: [9,37],
    negativeAccess: [863,855,917,883,1442,1444],
  },
  {
    title: 'Playback',
    path: '/playback',
    icon: getIcon('eva:archive-outline'),
    isHideInXs: false,
    positiveAccess: [],
    positiveUserRoles: [],
    negativeUserRoles: [9,37],
    negativeAccess: [863,855,917,883,1427,1428,1445,1442,1444],
  },
  {
    title: 'Escalated Events',
    path: '/escalatedEventsUS',
    icon: getIcon('eva:video-off-outline'),
    isHideInXs: false,
    positiveAccess: [],
    positiveUserRoles: [],
    negativeUserRoles: [30,37],
    negativeAccess: [917,883],
  },

   {
    title: 'Reports',
    path: '/report',
    icon: getIcon('eva:file-text-outline'),
    isHideInXs: false,
    positiveAccess: [1428,1445],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },

  {
    title: 'Cameras',
    path: '/client-cameras',
    icon: getIcon('eva:camera-outline'),
    isHideInXs: false,
    positiveAccess: [1428,1427,1438,1445,1444,1442],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },

  {
    title: 'Configuration',
    path: '/camera-combo-model-config',
    icon: getIcon('eva:settings-2-fill'),
    isHideInXs: false,
    openNewTab: true,
    positiveAccess: [1428,1427,1438,1445],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },

   {
    title: 'Live Heatmap',
    path: '/live-heatmap',
    icon: getIcon('mdi:heat-wave'),
    isHideInXs: false,
    positiveAccess: [1444,1442],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Reports',
    path: '/live-reports',
    icon: getIcon('iconoir:reports'),
    isHideInXs: false,
    positiveAccess: [1444,1442],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Manage Zones',
    path: '/live-timezones',
    icon: getIcon('bx:time'),
    isHideInXs: false,
    positiveAccess: [1444,1442],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },

  {
    title: 'Reports',
    path: '/us-reports',
    icon: getIcon('eva:file-text-outline'),
    isHideInXs: false,
    positiveAccess: [],
    positiveUserRoles: [],
    negativeUserRoles: [30, 37],
    negativeAccess: [917, 883,1427,1428,1445,1442,1444],
  },


  {
    title: 'License Plate Recognition Report',
    path: '/licensePlateRecognitionReport',
    icon: getIcon('eva:car-outline'),
    isHideInXs: false,
    positiveAccess: [1273],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  // {
  //   title: 'Contacts',
  //   path: '/contacts',
  //   icon: getIcon('eva:smartphone-outline'),
  //   isHideInXs: false,
  //   positiveAccess: [],
  //   positiveUserRoles: [],
  //   negativeUserRoles: [37],
  //   negativeAccess: [863,855,917,883],
  // },
  
  {
    title: 'Cameras',
    path: '/cameras',
    icon: getIcon('eva:camera-outline'),
    isHideInXs: false,
    positiveAccess: [917,863,883],
    positiveUserRoles: [],
    negativeUserRoles: [30, 33, 34, 35],
    negativeAccess: [],
  },

  // {
  //   title: 'Notifications',
  //   path: '/notifications',
  //   icon: getIcon('eva:bell-outline'),
  // isHideInXs: false
  // },


  // {
  //   title: 'Live Audits',
  //   path: 'live-audits',
  //   icon: getIcon('eva:shake-outline'),
  //   isHideInXs: true,
  //   positiveAccess: [],
  //   positiveUserRoles: [],
  //   negativeUserRoles: [],
  //   negativeAccess: [733, 790],
  // },  
  {
    title: 'Security Reports',
    path: 'reports',
    icon: getIcon('eva:book-outline'),
    isHideInXs: true,
    positiveAccess: [733],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Employee Reports',
    path: 'reportsinfc',
    icon: getIcon('eva:book-outline'),
    isHideInXs: true,
    positiveAccess: [917],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Events Report',
    path: 'jfw-reports',
    icon: getIcon('eva:book-outline'),
    isHideInXs: true,
    positiveAccess: [790],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Head Count Inputs',
    path: 'head-count-input',
    icon: getIcon('eva:book-outline'),
    isHideInXs: true,
    positiveAccess: [797,691],
    positiveUserRoles: [30, 2, 7],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'License Plates',
    path: 'license-plate',
    icon: getIcon('eva:car-outline'),
    isHideInXs: true,
    positiveAccess: [692],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: []
  },
  {
    title: 'Head Count Report',
    path: 'head-count-report',
    icon: getIcon('eva:funnel-outline'),
    isHideInXs: true,
    positiveAccess: [797,691],
    positiveUserRoles: [30, 2, 7],
    negativeUserRoles: [],
    negativeAccess: []
  },
  // {
  //   title: 'Shift Timings',
  //   path: 'shifttime',
  //   icon: getIcon('eva:people-outline'),
  //   isHideInXs: true,
  //   positiveAccess: [],
  //   positiveUserRoles: [],
  //   negativeUserRoles: [768,1193],
  //   negativeAccess: [],
  // },
  {
    title: 'Report',
    path: '/neterwala',
    icon: getIcon('eva:people-outline'),
    isHideInXs: false,
    positiveAccess: [765],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Dashboard',
    path: '/DashboardMdPSIT',
    icon: getIcon('eva:pie-chart-2-fill'),
    isHideInXs: false,
    positiveAccess: [37],
    positiveUserRoles: [37],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  //   {
  //   title: 'USDashboard',
  //   path: '/usClientDashboard',
  //   icon: getIcon('eva:pie-chart-2-fill'),
  //   isHideInXs: false,
  //   positiveAccess: [],
  //   positiveUserRoles: [],
  //   negativeUserRoles: [],
  //   negativeAccess: [],
  // },
  {
    title: 'Dashboard',
    path: '/DashboardSrmb',
    icon: getIcon('eva:pie-chart-2-fill'),
    isHideInXs: false,
    positiveAccess: [1191],
    positiveUserRoles: [1191],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Reports',
    path: '/mdReport',
    icon: getIcon('eva:file-text-outline'),
    isHideInXs: false,
    positiveAccess: [37],
    positiveUserRoles: [37],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Shows',
    path: '/addShow',
    icon: getIcon('eva:film-outline'),
    isHideInXs: false,
    positiveAccess: [883],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Reports',
    path: '/mohiniReport',
    icon: getIcon('eva:file-text-outline'),
    isHideInXs: false,
    positiveAccess: [883],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
    {
    title: 'Admin',
    path: '/Admin', 
    icon: getIcon('eva:person-outline'),
    isHideInXs: false, 
    positiveAccess: [],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [1427,1428,1445,1442,1444],
    children: [
       {
        title: 'Operations Team',
        path: '/operationsTeam',
        icon: getIcon('eva:people-outline'),
        isHideInXs: false, 
        positiveAccess: [],
        positiveUserRoles: [],
        negativeUserRoles: [],
        negativeAccess: [],
      },
      {
        title: 'Protocols',
        path: 'protocol', // Adjust the path as needed
        icon: getIcon('eva:settings-outline'),
        isHideInXs: false, // Adjust visibility as needed
        positiveAccess: [],
        positiveUserRoles: [],
        negativeUserRoles: [],
        negativeAccess: [],
      },
      {
        title: 'Share Login Access',
        path: '/addUserAccess',
        icon: getIcon('eva:people-outline'),
        isHideInXs: false, 
        positiveAccess: [],
        positiveUserRoles: [],
        negativeUserRoles: [],
        negativeAccess: [],
      },
       
      {
        title: 'Change Password',
        path: 'changepassword', 
        icon: getIcon('eva:settings-outline'),
        isHideInXs: false, 
        positiveAccess: [],
        positiveUserRoles: [],
        negativeUserRoles: [],
        negativeAccess: [],
      },
    ]
    },

];

export default navConfig;
